import { setTerms } from './helpers';

export const setDecorationsList = setTerms('decorations_list');
